module.exports = __webpack_public_path__ + "static/tags-db4c45d52e643dae30614834bcb57711.png";